import { Box } from "@mui/material";
import { RiskFactor } from "~/operations";
import { getRiskFactorIcon } from "~/pages/space/security/components/RiskFactors/utils";

const SORT_ORDER = [
  "high-priority",
  "internet-exposed",
  "internet-facing",
  "exploitable",
  "db-access",
  "user-risk",
  "asset-in-use",
  "patch-available",
  "code-execution",
  "sensitive-data",
  "port",
  "package",
  "credentials",
  "containers",
  "eol",
  "defensive",
  "low-priority",
];

export default function WorkflowAssetTableRiskFactorsCell({
  value,
}: {
  value: RiskFactor[];
}) {
  const icons = [...value]
    .sort((a, b) => {
      const indexA = SORT_ORDER.indexOf(a.indicator);
      const indexB = SORT_ORDER.indexOf(b.indicator);

      // Items not in sortOrder go to the end
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    })
    .slice(0, 4)
    .map((x) => getRiskFactorIcon({ indicator: x.indicator }));

  //get the number of risk factors not being displayed
  const remainingCount = value.length - icons.length;
  if (remainingCount > 0) {
    icons.push(
      <Box
        key="more-risk-factors"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          fontWeight: "bold",
          color: "warning.dark",
          mx: 0.5,
        }}
      >
        +{remainingCount}
      </Box>,
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      {icons.map((Icon, index) => (
        <Box key={index} sx={{ display: "flex", color: "icon.warning" }}>
          {Icon}
        </Box>
      ))}
    </Box>
  );
}
